/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetUserGaDataLayerDataModel,
  IGetUserGaDataLayerDataRequest,
  IMappers,
  IGetUserGaDataLayerDataResponse,
  IGetUserGaDataLayerDataResponseError,
  TGetUserGaDataLayerDataResponse,
} from './types';

const defaultConfig: TGetUserGaDataLayerDataModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-user-ga-data-layer-data/',
  hostType: 'api',
} as TGetUserGaDataLayerDataModel;

function createGetUserGaDataLayerDataModel(parameters: IGetUserGaDataLayerDataRequest): TGetUserGaDataLayerDataModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetUserGaDataLayerDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetUserGaDataLayerDataRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetUserGaDataLayerData<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetUserGaDataLayerDataOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetUserGaDataLayerDataResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetUserGaDataLayerDataModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetUserGaDataLayerDataResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetUserGaDataLayerDataResponseError);
    }
  }

  return { response, statusCode } as TGetUserGaDataLayerDataResponse;
}

export { defaultConfig, createGetUserGaDataLayerDataModel, fetchGetUserGaDataLayerData };
